<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Customização de Ficha Cautela
        </p>
      </div>
    </div>
    <div
      class="row col-12 text-brand-5 text-weight-bold q-mt-lg container-inputs"
    >
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
    </div>
    <div
      class="row col-12 text-brand-5 text-weight-bold q-mt-xl container-inputs"
    >
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="texto-titulo-input">Título da Ficha</div>
        <q-input
          v-model="dadosFicha.titulo"
          :bg-color="editar ? '' : 'brand-7'"
          :disable="!editar"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 q-mt-sm">
        <div class="texto-titulo-input">Subtítulo da Ficha</div>
        <q-input
          v-model="dadosFicha.subtitulo"
          :bg-color="editar ? '' : 'brand-7'"
          :disable="!editar"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 q-mt-sm">
        <div class="texto-titulo-input">Dizeres da Ficha</div>
        <q-input
          :bg-color="editar ? '' : 'brand-7'"
          :disable="!editar"
          dense
          outlined
          v-model="dadosFicha.dizeres"
          type="textarea"
          class="input"
        />
      </div>
      <div class="row col-12 justify-start q-mt-md">
        <div class="q-gutter-sm" v-if="!editar">
          <q-btn
            label="Editar"
            class="btn"
            icon="edit"
            color="primary"
            no-caps
            :disable="disable"
            @click="(editar = true), (dadosEditar = { ...dadosFicha })"
          />
          <q-select
            v-if="duplicar"
            dense
            outlined
            behavior="menu"
            label="Selecione a Unidade de destino"
            map-options
            v-model="unidadeDuplicar"
            :options="optionsUnidade"
          />
        </div>
        <div v-else class="q-gutter-sm">
          <q-btn
            v-if="
              dadosEditar.titulo && dadosEditar.subtitulo && dadosEditar.dizeres
            "
            label="Cancelar"
            icon="cancel"
            color="negative"
            no-caps
            class="btn"
            :disable="disable"
            @click="(editar = false), (dadosFicha = { ...dadosEditar })"
          />
          <q-btn
            label="Salvar"
            icon="check_circle_outline"
            color="positive"
            no-caps
            class="btn"
            :disable="disable"
            @click="verificarDadosCautela()"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const optionsUnidade = ref([]);
    const duplicar = ref(false);
    const unidadeDuplicar = ref();

    let editar = ref(true);
    const dadosFicha = ref({
      titulo: "",
      subtitulo: "",
      dizeres: "",
    });
    const dadosEditar = ref({
      titulo: "",
      subtitulo: "",
      dizeres: "",
    });
    const listaUnidades = ref([]);
    const unidade = ref({
      id: store.state.org.unidadeData.id,
      nome: store.state.org.unidadeData.nome,
      logo: store.state.org.unidadeData.logo,
    });
    let disable = ref(false);

    const receberDadosFichaCautela = async () => {
      resetVariaveis();
      if (
        store.state.org.unidadeData?.id == "" ||
        store.state.org.unidadeData?.id == undefined ||
        store.state.org.unidadeData?.id == null
      ) {
        editar.value = true;
        return;
      }
      disable.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/receberDadosFichaCautela",
          {
            vendor_id: store.state.org.unidadeData.id,
            funcionarioId: store.state.autenticacao.usuarioLogado.id,
          }
        );
        editar.value = false;
        if (
          response.data.resultado.mensagem.fichaCautela.titulo == "" &&
          response.data.resultado.mensagem.fichaCautela.subtitulo == "" &&
          response.data.resultado.mensagem.fichaCautela.dizeres == ""
        ) {
          editar.value = true;
          dadosFicha.value = {
            titulo: "",
            subtitulo: "",
            dizeres: "",
          };
          disable.value = false;
          return;
        }
        dadosFicha.value = {
          titulo: response.data.resultado.mensagem.fichaCautela.titulo,
          subtitulo: response.data.resultado.mensagem.fichaCautela.subtitulo,
          dizeres: response.data.resultado.mensagem.fichaCautela.dizeres,
        };
        dadosEditar.value = { ...dadosFicha.value };
        disable.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        editar.value = true;
      }
    };

    const editarDadosFichaCautela = async () => {
      if (
        !store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
          "cautela-cautela-criar"
        )
      ) {
        quasar.notify({
          message: "Você não tem permissão para editar.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        editar.value = false;
        receberDadosFichaCautela();
        return;
      }
      if (
        store.state.org.unidadeData?.id == "" ||
        store.state.org.unidadeData?.id == undefined ||
        store.state.org.unidadeData?.id == null
      ) {
        quasar.notify({
          message: "Selecione uma unidade.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        dadosEditar.value.titulo === dadosFicha.value.titulo &&
        dadosEditar.value.subtitulo === dadosFicha.value.subtitulo &&
        dadosEditar.value.dizeres === dadosFicha.value.dizeres
      ) {
        editar.value = false;
        return;
      }
      try {
        await store.dispatch("ferramentaria/editarDadosFichaCautela", {
          vendor_id: store.state.org.unidadeData.id,
          titulo: dadosFicha.value.titulo,
          subtitulo: dadosFicha.value.subtitulo,
          dizeres: dadosFicha.value.dizeres,
        });
        receberDadosFichaCautela();
        quasar.notify({
          message: "Dados editados com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarDadosFichaCautela = async () => {
      if (
        !store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
          "cautela-cautela-criar"
        )
      ) {
        quasar.notify({
          message: "Você não tem permissão para criar.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        receberDadosFichaCautela();
        editar.value = false;
        return;
      }
      if (
        store.state.org.unidadeData?.id == "" ||
        store.state.org.unidadeData?.id == undefined ||
        store.state.org.unidadeData?.id == null
      ) {
        quasar.notify({
          message: "Selecione uma unidade.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("ferramentaria/editarDadosFichaCautela", {
          vendor_id: store.state.org.unidadeData.id,
          titulo: dadosFicha.value.titulo,
          subtitulo: dadosFicha.value.subtitulo,
          dizeres: dadosFicha.value.dizeres,
        });
        receberDadosFichaCautela();
        quasar.notify({
          message: "Dados criados com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        let array = response.listaUnidades;
        array.forEach((unidade) => {
          optionsUnidade.value.push({
            label: unidade.nome,
            id: unidade.id,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(listarUnidades);

    const deletarDadosFichaCautela = async () => {
      if (
        !store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
          "cautela-cautela-criar"
        )
      ) {
        quasar.notify({
          message: "Você não tem permissão para deletar.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("ferramentaria/deletarDadosFichaCautela", {
          vendor_id: store.state.org.unidadeData.id,
        });
        receberDadosFichaCautela();
        resetVariaveis();
      } catch (error) {
        quasar.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const duplicarCustom = async () => {
      try {
        await store.dispatch("ferramentaria/duplicarDadosFichaCautela", {
          vendor_id: store.state.org.unidadeData.id,
          vendor_id_alvo: unidadeDuplicar.value.id,
        });
        quasar.notify({
          message: "Duplicado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        receberDadosFichaCautela();
        resetVariaveis();
        duplicar.value = false;
      } catch (error) {
        quasar.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificarDadosCautela = () => {
      if (
        dadosEditar.value.titulo === "" &&
        dadosEditar.value.subtitulo === "" &&
        dadosEditar.value.dizeres === ""
      ) {
        criarDadosFichaCautela();
        return;
      }
      editarDadosFichaCautela();
    };

    const resetVariaveis = () => {
      dadosFicha.value = {
        titulo: "",
        subtitulo: "",
        dizeres: "",
      };
      dadosEditar.value = {
        titulo: "",
        subtitulo: "",
        dizeres: "",
      };
    };

    watch(
      () => store.state.org.unidadeData?.id,
      () => {
        resetVariaveis();
        receberDadosFichaCautela();
      }
    );

    onMounted(() => {
      receberDadosFichaCautela();
    });

    return {
      editar,
      dadosFicha,
      receberDadosFichaCautela,
      criarDadosFichaCautela,
      dadosEditar,
      deletarDadosFichaCautela,
      verificarDadosCautela,
      editarDadosFichaCautela,
      resetVariaveis,
      listaUnidades,
      unidade,
      disable,
      listarUnidades,
      optionsUnidade,
      unidadeDuplicar,
      duplicar,
      duplicarCustom,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .btn {
    font-size: 13px;
  }
}
</style>
